import { createFeatureSelector, createSelector } from '@ngrx/store';
import { payrateFeatureKey } from './pay-rate-reducer';
import { PayRateState } from './state/pay-rate.state';

export const selectPayRateFeatureState = createFeatureSelector<PayRateState>(payrateFeatureKey);

export const selectBillingPayRates = createSelector(selectPayRateFeatureState, (state) => state?.billingRates);

export const selectIncentivePayRates = createSelector(selectPayRateFeatureState, (state) => state?.incentiveRates);

export const selectUpdateBillingPayRatesError = createSelector(selectPayRateFeatureState, (state) => state?.error);

export const selectFacilityId = createSelector(selectPayRateFeatureState, (state) => state?.facilityId);

export const selectFacilitySystemId = createSelector(selectPayRateFeatureState, (state) => state?.facilitySystemId);

export const selectLastFetchArgs = createSelector(selectPayRateFeatureState, (state) => state?.lastFetchArgs);

export const selectSignalRLoading = createSelector(selectPayRateFeatureState, (state) => state?.signalRLoading);

export const selectShiftDiffLookup = createSelector(
    selectPayRateFeatureState,
    (state) => state?.shiftDifferentialTypes
);
